import { render, staticRenderFns } from "./AccountHolderAuthorizedSigners.vue?vue&type=template&id=b22859b4&scoped=true"
import script from "./AccountHolderAuthorizedSigners.vue?vue&type=script&lang=ts"
export * from "./AccountHolderAuthorizedSigners.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderAuthorizedSigners.vue?vue&type=style&index=0&id=b22859b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22859b4",
  null
  
)

export default component.exports